module.exports = __webpack_public_path__ + "static/media/icon-tel.b9187c02.svg";